module.exports = [{"name":"Jimmy Buffet","gp":82,"g":12,"a":12,"p":55,"pm":-2,"cf":54,"age":32,"henri":9.2,"cap":8.7,"surplus":5.6,"position":"LW"},{"name":"dsads sadasd","gp":80,"g":22,"a":34,"p":56,"pm":-2,"cf":54,"age":26,"henri":6.9,"cap":7.4,"surplus":4.2,"position":"C"}]


//////////////////
// WEBPACK FOOTER
// ./src/Mock/trade-team-one-prospects.json
// module id = 1408
// module chunks = 0